module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_14_A.c55193bb.mp3";